export default function Alert(theme) {
  return {
    MuiAlert: {

    }
  };
}
